import { MultiChoicePostInput } from '../../templates/inputs/MultiChoicePostInput';
import { ThisOrThatPostInput } from '../../templates/inputs/ThisOrThatPostInput';
import { VoteSliderPostInput } from '../../templates/inputs/VoteSliderPostInput';
import { getDefaultPollByType } from '../components/PollArticlePage';
import {
    isMultiChoicePost,
    isThisOrThatPost,
    isVoteSliderPost,
} from '../PostTypes';
import { MultiChoicePostData } from '../types/MultiChoicePostData';
import { ThisOrThatPostData } from '../types/ThisOrThatPostData';
import { VoteSliderPostData } from '../types/VoteSliderPostData';
import { defineTemplate } from './TemplateUtils';

export const ThisOrThatMedium = defineTemplate(
    'ThisOrThatPoll',
    'Medium',
    ThisOrThatPostInput,
    () =>
        ({
            $type: 'ThisOrThatPoll',
            size: 'Medium',
            pages: [
                {
                    poll: getDefaultPollByType('ThisOrThat'),
                },
            ],
        }) satisfies ThisOrThatPostData,
    isThisOrThatPost,
);

export const ThisOrThatLarge = defineTemplate(
    'ThisOrThatPoll',
    'Large',
    ThisOrThatPostInput,
    () =>
        ({
            $type: 'ThisOrThatPoll',
            size: 'Large',
            pages: [
                {
                    poll: getDefaultPollByType('ThisOrThat'),
                },
            ],
        }) satisfies ThisOrThatPostData,
    isThisOrThatPost,
);

export const VoteSliderMedium = defineTemplate(
    'VoteSliderPoll',
    'Medium',
    VoteSliderPostInput,
    () =>
        ({
            $type: 'VoteSliderPoll',
            size: 'Medium',
            pages: [
                {
                    poll: getDefaultPollByType('VoteSlider'),
                },
            ],
        }) satisfies VoteSliderPostData,
    isVoteSliderPost,
);

export const VoteSliderLarge = defineTemplate(
    'VoteSliderPoll',
    'Large',
    VoteSliderPostInput,
    () =>
        ({
            $type: 'VoteSliderPoll',
            size: 'Large',
            pages: [
                {
                    poll: getDefaultPollByType('VoteSlider'),
                },
            ],
        }) satisfies VoteSliderPostData,
    isVoteSliderPost,
);

export const MultiChoiceMedium = defineTemplate(
    'MultiChoicePoll',
    'Medium',
    MultiChoicePostInput,
    () =>
        ({
            $type: 'MultiChoicePoll',
            size: 'Medium',
            pages: [
                {
                    poll: getDefaultPollByType('MultiChoice'),
                },
            ],
        }) satisfies MultiChoicePostData,
    isMultiChoicePost,
);

export const MultiChoiceLarge = defineTemplate(
    'MultiChoicePoll',
    'Large',
    MultiChoicePostInput,
    () =>
        ({
            $type: 'MultiChoicePoll',
            size: 'Large',
            pages: [
                {
                    poll: getDefaultPollByType('MultiChoice'),
                },
            ],
        }) satisfies MultiChoicePostData,
    isMultiChoicePost,
);
